export default __webpack_public_path__ + "static/media/bagSVG.4f96b64e.svg";